import { render, staticRenderFns } from "./DateSearch.vue?vue&type=template&id=6622a671&"
import script from "./DateSearch.vue?vue&type=script&lang=js&"
export * from "./DateSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports